import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import pointsReducer from './pointsSlice';
import worldReducer from './worldSlice';
import colorsReducer from './colorsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    points: pointsReducer,
    world: worldReducer,
    colors: colorsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;